const NO_PUSH_ACTIONS = [ 'registration_closed', 'round_signup_closed', 'leaderboard_live' ]

const t = (key, opts) => (window.I18n ? window.I18n.t(key, opts) : '')

export const clubFeedChannelsArmed = (channels) => Boolean(channels && channels.feed)

export const clubFeedPushAnnounced = (action, channels) => {
  if (!action || !clubFeedChannelsArmed(channels)) {
    return false
  }
  if (!(channels.push || channels.push_notification)) {
    return false
  }

  return !NO_PUSH_ACTIONS.includes(action)
}

export const clubFeedPopupTitle = (action, channels) => (
  clubFeedPushAnnounced(action, channels) ? t('club_feed.popup.title_with_push') : t('club_feed.popup.title')
)

export const clubFeedChannelsMessage = (action, channels, product) => {
  if (!action || !clubFeedChannelsArmed(channels)) {
    return null
  }

  const variant = clubFeedPushAnnounced(action, channels) ? 'with_push' : 'board_only'

  return t(`club_feed.messages.${ action }.${ variant }`, { product })
}

export default clubFeedChannelsMessage
